import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getMomentLocale } from './appLocale';

const SUMMARY_CATEGORY_KEYS = {
  RRHH: 'rrhh',
  Proveedores: 'proveedores',
  administrativos: 'administrativos',
  financieros: 'financieros',
  fiscales: 'fiscales',
  dividendos: 'dividendos',
};

const SUMMARY_FIELD_KEYS = {
  sueldos: 'sueldos',
  imposiciones: 'leyes_sociales',
  anticipos: 'anticipos',
  finiquitos: 'finiquitos',
  proveedoresCriticos: 'proveedoresCriticos',
  arriendos: 'arriendo',
  gastosComunes: 'ggcc_&_servicios_basicos',
  creditos: 'cuota_credito',
  tarjetasCredito: 'tarjeta_de_credito',
  financiamientos: 'capital_de_trabajo',
  lineaSobregiro: 'sobregiro_cuenta_corriente',
  impuestos: 'impuesto_a_la_renta',
  conveniosTGR: 'convenios_tgr',
  IVAPostergado: 'iva_postergado',
  pagosSocios: 'dividendo',
};

export function useCashPositionLabels() {
  const { t } = useTranslation('dashboard');

  return useMemo(() => {
    const category = (key) =>
      t(`cashPosition.categories.${key}`, { defaultValue: key });
    const field = (key) =>
      t(`cashPosition.fields.${key}`, { defaultValue: key });

    const summaryRow = (key) => {
      if (SUMMARY_CATEGORY_KEYS[key]) {
        return category(SUMMARY_CATEGORY_KEYS[key]);
      }
      if (SUMMARY_FIELD_KEYS[key]) {
        return field(SUMMARY_FIELD_KEYS[key]);
      }
      return key;
    };

    return { category, field, summaryRow };
  }, [t]);
}

export function getCashPositionMomentLocale(language) {
  return getMomentLocale(language);
}
